import axios from 'axios';

export const GetCompanyAPI = async (data, onSuccess, onError)=>{
    try{
        const res = await axios.get("/get/company", {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });

        onSuccess && onSuccess(res);
    }
    catch(err){
        onError && onError(err);
    }
}